var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountersignedAgreementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#93E5C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0023 22.0009V27.0029C26.0023 28.108 25.1065 29.0038 24.0015 29.0038H12.9969C11.8919 29.0038 10.9961 28.108 10.9961 27.0029V12.9971C10.9961 11.8921 11.8919 10.9963 12.9969 10.9963H24.0015C25.1065 10.9963 26.0023 11.8921 26.0023 12.9971V15.9984",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 21.4146V24.0017H23.5871C23.8524 24.0017 24.1068 23.8962 24.2944 23.7085L28.3821 19.6208C29.2105 18.7919 29.2105 17.4485 28.3821 16.6196V16.6196C27.5531 15.7912 26.2098 15.7912 25.3808 16.6196L21.2931 20.7073C21.1055 20.8949 21 21.1493 21 21.4146Z",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.998 20H17.9993",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.998 24.0017H17.9993",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.998 15.9984H22.001",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountersignedAgreementIcon);
export default __webpack_public_path__ + "static/media/CountersignedAgreementIcon.eddd3e2527db4d821f45d52ba576c437.svg";
export { ForwardRef as ReactComponent };